import { render, staticRenderFns } from "./addGift.vue?vue&type=template&id=9e3445c0&scoped=true&"
import script from "./addGift.vue?vue&type=script&lang=js&"
export * from "./addGift.vue?vue&type=script&lang=js&"
import style0 from "./addGift.vue?vue&type=style&index=0&id=9e3445c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3445c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e3445c0')) {
      api.createRecord('9e3445c0', component.options)
    } else {
      api.reload('9e3445c0', component.options)
    }
    module.hot.accept("./addGift.vue?vue&type=template&id=9e3445c0&scoped=true&", function () {
      api.rerender('9e3445c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/gift/components/addGift.vue"
export default component.exports